import styled from 'styled-components';
import { PulseDot } from '#/shared/components/PulseDot';

export const CurrentLocationMarker = styled(PulseDot).attrs(({ theme }) => ({
  color: theme.currentPositionColor,
}))`
  &:hover {
    cursor: pointer;
  }
`;

export default CurrentLocationMarker;
